module.exports = __webpack_public_path__ + "media/promo/velle/images/recipes/recipe_6-424aa3f1d75f008f851510797ae6034f.jpg";